import { NgModule } from '@angular/core';
import { COLLECTION_VALUE_NORMALIZER, CollectionValueNormalizer } from './connectors';
import { CmsContentTagStoreModule } from './store/cms-content-tag-store.module';

@NgModule({
  imports: [CmsContentTagStoreModule],
  providers: [
    {
      provide: COLLECTION_VALUE_NORMALIZER,
      useClass: CollectionValueNormalizer,
      multi: true,
    },
  ],
})
export class CmsContentTagBaseModule {}
